import { HttpService } from '@src/api/common/HttpService';
import { UrlService } from '@src/api/common/UrlService';
import { CTE_API_URL } from '@src/constants/BaseUrls';

type RoleType = {
  id: number | string;
};

export const ActivityLogService = () => {
  const { HttpGet, HttpPost, HttpDelete } = HttpService();

  const GetAll = async (body: any) => {
    const url = `${CTE_API_URL}/api/v1/activity-logs${body}`;
    const response = await HttpGet(url);
    return response;
  };

  return {
    GetAll,
  };
};
